import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { LocalStorageService } from 'src/app/local-storage.service';
import { Page } from 'src/app/page';
import { Subject } from 'src/models/subject.model';
import { CpsuSubjectService } from 'src/services/cpsu-subject.service';
import { CustomPaginationService } from 'src/services/custom-pagination.service';
import { SharedCaseService } from 'src/services/shared-case.service';
import { SearchItem } from '../subjects.component';
import { UserService } from 'src/services/user.service';

@Component({
   selector: 'app-cpsu-registry',
   templateUrl: './cpsu-registry.component.html',
   styleUrls: ['./cpsu-registry.component.scss'],
})
export class CpsuRegistryComponent implements OnInit, OnChanges {
   @Output() loadingCompleted = new EventEmitter();
   @Output() emitPageData = new EventEmitter();
   @Output() rowClickedEvent = new EventEmitter();
   @Output() handleOpenDialogEvent = new EventEmitter();

   @Input() getFirstPageEvent: any;
   @Input() getPreviousPageEvent: any;
   @Input() getNextPageEvent: any;
   @Input() getLastPageEvent: any;
   @Input() getPageInNewSizeEvent: any;
   @Input() applyFilterEvent: any;
   @Input() changeCenterEvent: any;
   @Input() object: any = { origin: '' };
   @Input() customFilterFormValue: any;
   @Input() filterInUse: boolean = false;

   readonly separatorKeysCodes: number[] = [COMMA, ENTER];
   public searchTerms: string[] = [];

   public globalFilter: any = '';
   public searchItems: SearchItem[] = [];
   page: Page<Subject> = new Page();
   myInput = '';
   isUserManager = false;
   displayedColumns: string[] = ['csrName', 'registrationId', 'lastName', 'firstName', 'parentName', 'dateOfBirth', 'jmbg', 'status'];
   fileUrl: any;
   subcenter = new FormControl();
   subcenterCsrId: any;
   subcenters = [];
   loggedIn: any;
   areLoaded = false;
   allCsrCodebooks = [];
   filteredSubcenters: Observable<any>;
   paramsObject: any;
   loadParams = true;
   isMainCenterBelgrade = false;
   isUserDrugostepeni = false;

   constructor(
      private sharedCaseService: SharedCaseService,
      public dialog: MatDialog,
      private paginationService: CustomPaginationService,
      public router: Router,
      private route: ActivatedRoute,
      private cpsuSubjectService: CpsuSubjectService,
      private localStorageService: LocalStorageService,
      private userService: UserService
   ) {
      this.loggedIn = JSON.parse(this.localStorageService.get('loggedUser'));
      this.isUserManager = this.userService.isUserManager();
      this.isUserDrugostepeni = userService.isUserDrugostepeni();
      this.isMainCenterBelgrade = this.loggedIn?.csrId === '1' ? true : false;
      if (this.isUserDrugostepeni || this.isMainCenterBelgrade) {
         if (this.localStorageService.get('localStorageSubcenter') !== null) {
            const localStorageSubcenter = JSON.parse(this.localStorageService.get('localStorageSubcenter'));
            this.subcenterCsrId = localStorageSubcenter.id;
            this.subcenter.setValue(localStorageSubcenter);
         } else {
            this.subcenterCsrId = 0;
         }
      } else {
         this.subcenterCsrId = this.loggedIn?.csrId;
      }
      if (this.isUserManager) {
         this.displayedColumns.push('actions');
      }
      this.localStorageService.remove('case');

      this.clearSharedCaseService(); // Treba da se obrise da ne bi pamtio tabove o detaljima predmeta

      this.getQueryParams();
   }

   ngOnChanges(changes: SimpleChanges): void {
      if (changes.getFirstPageEvent) {
         this.getFirstPage();
      } else if (changes.getLastPageEvent) {
         this.getLastPage();
      } else if (changes.getPreviousPageEvent) {
         this.getPreviousPage();
      } else if (changes.getNextPageEvent) {
         this.getNextPage();
      } else if (changes.getPageInNewSizeEvent) {
         this.getPageInNewSize(this.getPageInNewSizeEvent);
      } else if (changes.applyFilterEvent) {
         this.applyFilter(this.applyFilterEvent);
      } else if (changes.changeCenterEvent) {
         this.changeCenter(this.changeCenterEvent);
      }
   }

   ngOnInit(): void {}
   public getNextPage(): void {
      this.areLoaded = false;
      this.loadingCompleted.emit(false);
      this.page.pageable = this.paginationService.getNextPage(this.page);
      this.doFilter();
   }

   public getPreviousPage(): void {
      this.areLoaded = false;
      this.loadingCompleted.emit(false);
      this.page.pageable = this.paginationService.getPreviousPage(this.page);
      this.doFilter();
   }

   public getFirstPage(): void {
      this.areLoaded = false;
      this.loadingCompleted.emit(false);
      this.page.pageable = this.paginationService.getFirstPage(this.page);
      this.doFilter();
   }

   public getLastPage(): void {
      this.areLoaded = false;
      this.loadingCompleted.emit(false);
      this.page.pageable = this.paginationService.getLastPage(this.page);
      this.doFilter();
   }

   public getPageInNewSize(pageSize: any): void {
      this.areLoaded = false;
      this.loadingCompleted.emit(false);
      this.page.pageable = this.paginationService.getPageInNewSize(this.page, pageSize);
      this.doFilter();
   }

   doFilter() {
      this.setQueryParams();
        const body = {
         pageId: this.page.pageable.pageNumber,
         sizeId: this.page.pageable.pageSize,
         csrId: this.isMainCenterBelgrade || this.isUserDrugostepeni ? this.subcenterCsrId : this.loggedIn?.csrId,
         searchData: (this.globalFilter === '' ? this.myInput : this.globalFilter) === '' ? [] : this.globalFilter === '' ? this.myInput : this.globalFilter,
         status: this.filterInUse ? this.customFilterFormValue.status : null,
         address: this.filterInUse && this.customFilterFormValue.address != '' ? this.customFilterFormValue.address : null,
      };
      this.cpsuSubjectService.getFilteredPage(body).subscribe(page => {
         this.page = page;
         this.page.pageable.pagePerShow = page.number + 1;
         for (const element of this.page.content) {
            if (element.dateOfBirth !== null) {
               element.dateOfBirth = (element.dateOfBirth as any).replace(/(\d{2})\/(\d{2})\/(\d{4})/, '$2/$1/$3');
            }
         }
         this.emitPageData.emit(this.page);
         this.loadingCompleted.emit(true);
         this.areLoaded = true;
      });
   }

   setQueryParams() {
      let params = {
         pageNum: null,
         size: null,
         filter: this.globalFilter === '' ? null : this.globalFilter,
         status: this.filterInUse ? this.customFilterFormValue.status : null,
         address: this.filterInUse && this.customFilterFormValue.address !== '' ? this.customFilterFormValue.address : null,
      };
      if (this.object.origin === undefined) {
         if (this.page.pageable.pageNumber !== 0) {
            params = {
               pageNum: this.page.pageable.pageNumber,
               size: this.page.pageable.pageSize,
               status: this.filterInUse ? this.customFilterFormValue.status : null,
               address: this.filterInUse && this.customFilterFormValue.address !== '' ? this.customFilterFormValue.address : null,
               filter: this.globalFilter === '' ? null : this.globalFilter,
            };
         }
         this.router.navigate([], {
            relativeTo: this.route,
            queryParams: params,
            replaceUrl: true,
         });
      }
   }

   getQueryParams() {
      this.route.queryParamMap.subscribe(params => {
         if (this.loadParams === true) {
            this.paramsObject = { ...params.keys, ...params };
            const param = this.paramsObject.params;
            this.page.pageable.pageNumber = param?.pageNum ? param?.pageNum : this.page.pageable.pageNumber;
            this.page.pageable.pageSize = param?.size ? param?.size : this.page.pageable.pageSize;

            if (param?.filter) {
               this.searchItems = [];
               this.globalFilter = Array.isArray(param?.filter) ? param?.filter : [param?.filter];
               for (const filter of this.globalFilter) {
                  this.searchItems.push({ name: filter });
               }
            }
            if (param?.status) {
               this.filterInUse = true;
               this.customFilterFormValue.status = param?.status;
            }
            if (param?.address) {
               this.filterInUse = true;
               this.customFilterFormValue.address = param?.address;
            }

            this.loadParams = false;
         }
      });
   }

   handleOpenDialog(element: any) {
      this.handleOpenDialogEvent.emit(element);
   }

   onRowClicked(element: any) {
      this.rowClickedEvent.emit(element);
   }

   clearSharedCaseService() {
      this.sharedCaseService.tabs = [];
      this.sharedCaseService.activeTab = null;
   }

   applyFilter(filterValue: any) {
      this.globalFilter = filterValue;
      this.page.pageable.pageNumber = 0;
      this.doFilter();
   }
   changeCenter(event: any) {
      this.subcenterCsrId = event?.id;
      this.getFirstPage();
   }
}
